import React from 'react';
import { Switch, Route } from 'react-router';
import AccountEdit from './AccountEdit';
import AccountCreate from './AccountCreate';

const Account = () => (
  <Switch>
    <Route path="/dashboard/admin/organizations/new">
      <AccountCreate />
    </Route>
    <Route
      exact
      path={[
        '/dashboard/admin/organizations/:id/account',
        '/dashboard/user/organizations/:id/account',
      ]}
    >
      <AccountEdit />
    </Route>
  </Switch>
);
export default Account;
